import { SpeakingCharacterStudio } from "../components/SpeakingCharacterStudio";

export function GenerateAds({ onBack, onGenerate, projectName, initialScript, aiCmoId, conceptId }) {
  return (
    <SpeakingCharacterStudio 
      embedded={true} 
      projectName={projectName}
      onGenerate={onGenerate}
      initialScript={initialScript}
      aiCmoId={aiCmoId}
      conceptId={conceptId}
      onBack={onBack}
    />
  );
}